export class Passenger {
    uuid_passenger!: string;
    displayName!: string;
    badge_number!: string;
    selected?: boolean;
}